{
  "401": {
    "title": "Você não está autorizado a acessar esta página.",
    "text": "Se você acha que isso não está certo, entre em contato com o administrador",
    "back_button": "Voltar para o painel"
  },
  "403": {
    "title": "Você não tem permissão para acessar esta página.",
    "text": "Se você acha que isso é um erro, por favor, entre em contato com o administrador.",
    "back_button": "Voltar para o painel"
  },
  "404": {
    "title": "Esta página não foi encontrada.",
    "text": "A página solicitada não pôde ser encontrada.",
    "back_button": "Voltar para o painel"
  },
  "general": {
    "dateFormat": "dd/MM/yyyy",
    "fullDateFormat": "dd/MM/yyyy HH:mm:ss",
    "logout": "Sair",
    "account": "Conta",
    "profile": "Perfil",
    "hello": "Olá",
    "home": "Início",
    "loading": "Carregando...",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "close": "Fechar",
    "view": "Visualizar",
    "save": "Salvar",
    "records": "Registros",
    "add": "Adicionar",
    "read": "Ler",
    "write": "Salvar",
    "edit": "Editar",
    "new": "Novo",
    "delete": "Excluir",
    "actions": "Ações",
    "active": "Ativo",
    "inactive": "Inativo",
    "search": "Pesquisar",
    "select": "Selecionar",
    "none": "Nenhum",
    "yes": "Sim",
    "no": "Não",
    "years": "Anos",
    "months": "Meses",
    "favorites": "Favoritos",
    "reports": "Relatórios",
    "recordsPerPage": "Registros por página",
    "changePassword": "Alterar senha",
    "longDateFormat": "{years} ano(s) e {months} mês(es)",
    "importData": "Importar dados",
    "upload": "Enviar",
    "downloadTemplate": "Baixar modelo",
    "selectOption": "Selecione uma opção",
    "id": "ID",
    "translations": "Traduções",
    "or": "ou",
    "review": "Revisar",
    "approve": "Aprovar",
    "reject": "Rejeitar",
    "reviewComments": "Comentários de Revisão",
    "reviewOnBehalfOf": "Revisar em nome de",
    "reviewed": "Revisado",
    "reviewedBy": "Revisado Por ",
    "pending": "Pendente",
    "approved": "Aprovado",
    "rejected": "Rejeitado",
    "skipped": "Ignorado",
    "warning": "Aviso",
    "move": "Mover",
    "leave": "Sair",
    "export": "Exportar",
    "import": "Importar",
    "next": "Próximo",
    "previous": "Anterior",
    "done": "Concluído",
    "run": "Executar",
    "form": "Formulário",
    "emailTemplate": "Modelo de E-mail",
    "send": "Enviar",
    "saving": "Salvando...",
    "saved": "Salvo",
    "loadData": "Carregar Dados",
    "exportCsv": "Exportar CSV",
    "auditFields": "Campos de auditoria",
    "saveDisplayOrder": "Salvar ordem de exibição",
    "attach": "Anexar",
    "download": "Baixar",
    "noData": "Nenhum registro encontrado",
    "cropImage": "Recortar imagem",
    "selectImageToCrop": "Selecione uma imagem para recortar",
    "selectImage": "Selecionar imagem",
    "list": "Lista",
    "group": "Grupo",
    "manager": "Gerente",
    "status": "Status",
    "permissionActions": {
      "read": "Ler",
      "write": "Escrever",
      "delete": "Excluir",
      "execute": "Executar"
    },
    "messages": {
      "formUnsavedChanges": "Você tem alterações não salvas. Tem certeza de que deseja fechar?",
      "serverError": "Erro do servidor. Por favor, tente novamente mais tarde ou entre em contato com o administrador do sistema.",
      "networkError": "Não foi possível conectar ao servidor. Verifique sua conexão com a internet ou entre em contato com o administrador do sistema.",
      "forbidden": "Você não tem permissão para acessar este recurso. Entre em contato com o administrador do sistema se achar que isso é um erro.",
      "fileUploadError": "Erro ao enviar o arquivo. Verifique o formato e o tamanho do arquivo e tente novamente.",
      "fileUploadSuccessEmail": "Arquivo enviado com sucesso. Um e-mail com o resultado da importação será enviado em breve.",
      "failedLoadPermissions": "Falha ao carregar as permissões do usuário. Por favor, atualize a página ou entre em contato com o administrador do sistema.",
      "downloadingFile": "Baixando arquivo...",
      "fileDownloadError": "Erro ao baixar o arquivo. Por favor, tente novamente ou entre em contato com o administrador do sistema.",
      "fileImportedSuccessfully": "Arquivo importado com sucesso.",
      "invalidFileFormat": "Formato de arquivo inválido. Verifique o arquivo e tente novamente.",
      "exportFailed": "Falha ao exportar dados. Tente novamente ou entre em contato com o administrador do sistema.",
      "personNotFound": "Pessoa não encontrada. Entre em contato com o administrador.",
      "notRegisteredSessionOnly": "Você não está registrado no JTP, então esta alteração será aplicada somente à sua sessão atual. Entre em contato com o administrador para ser adicionado."
    },
    "warnings": {
      "maxDisplayedRecords": "Exibindo {shown} registros de {filtered}. Para ver mais registros, utilize a função de pesquisa."
    },
    "validation": {
      "required": "Este campo é obrigatório.",
      "email": "Por favor, insira um endereço de e-mail válido.",
      "minValue": "O valor deve ser pelo menos {min}.",
      "maxValue": "O valor não pode ser maior que {max}.",
      "minLength": "O valor deve ter pelo menos {min} caracteres.",
      "maxLength": "O valor não pode ter mais de {max} caracteres.",
      "onlyIntegers": "O valor deve ser um número inteiro.",
      "invalidDate": "A data informada é inválida."
    },
    "baseAuditableEntity": {
      "createdBy": "Criado por",
      "createdDate": "Data de criação",
      "modifiedBy": "Modificado por",
      "modifiedDate": "Data de modificação"
    },
    "info": {
      "dragAndDropInfo": "Arraste e solte qualquer pessoa para organizar a árvore"
    }
  },
  "enums": {
    "potentialSuccessorType": {
      "1": "Interno",
      "2": "Externo"
    },
    "readinessFactor": {
      "0": "N/A",
      "1": "Pronto Agora",
      "2": "Pronto com Desenvolvimento (1-2 Anos)",
      "3": "Pronto com Desenvolvimento (2-3 Anos)",
      "4": "Reposição de Emergência"
    },
    "positionType": {
      "1": "Comprar",
      "2": "Fazer",
      "3": "Vender",
      "4": "Suporte"
    },
    "communicationPriority": {
      "1": "Normal",
      "2": "Alta"
    }
  },
  "report": {
    "viewer": {
      "grid": {
        "pivotMode": "Modo Pivô",
        "groups": "Grupos de Linhas",
        "rowGroupColumnsEmptyMessage": "Arraste aqui para definir grupos de linhas",
        "values": "Valores",
        "valueColumnsEmptyMessage": "Arraste aqui para agregar",
        "pivots": "Rótulos de Coluna",
        "pivotColumnsEmptyMessage": "Arraste aqui para definir rótulos de coluna",
        "columns": "Colunas",
        "filters": "Filtros",
        "loadingOoo": "Carregando...",
        "noRowsToShow": "Nenhuma linha para mostrar",
        "enabled": "Habilitado",
        "group": "Grupo",
        "footerTotal": "Total",
        "filterOoo": "Filtrar...",
        "searchOoo": "Pesquisar...",
        "blanks": "(Vazios)",
        "selectAll": "(Selecionar Todos)",
        "selectAllSearchResults": "(Selecionar Todos os Resultados da Pesquisa)",
        "noMatches": "Nenhuma correspondência",
        "equals": "Igual",
        "notEqual": "Diferente",
        "blank": "Vazio",
        "notBlank": "Não vazio",
        "lessThan": "Menor que",
        "greaterThan": "Maior que",
        "lessThanOrEqual": "Menor ou igual a",
        "greaterThanOrEqual": "Maior ou igual a",
        "inRange": "Entre",
        "inRangeStart": "De",
        "inRangeEnd": "Até",
        "contains": "Contém",
        "notContains": "Não contém",
        "startsWith": "Começa com",
        "endsWith": "Termina com",
        "before": "Antes",
        "after": "Depois",
        "andCondition": "E",
        "orCondition": "OU",
        "applyFilter": "Aplicar",
        "resetFilter": "Redefinir",
        "clearFilter": "Limpar",
        "cancelFilter": "Cancelar",
        "textFilter": "Filtro de Texto",
        "numberFilter": "Filtro de Número",
        "dateFilter": "Filtro de Data",
        "setFilter": "Filtro de Conjunto",
        "pinColumn": "Fixar Coluna",
        "pinLeft": "Fixar à Esquerda",
        "pinRight": "Fixar à Direita",
        "noPin": "Não Fixar",
        "valueAggregation": "Agregação de Valores",
        "noAggregation": "Nenhuma",
        "autosizeThisColumn": "Autoajustar Esta Coluna",
        "autosizeAllColumns": "Autoajustar Todas as Colunas",
        "groupBy": "Agrupar por",
        "ungroupBy": "Desagrupar por",
        "ungroupAll": "Desagrupar Tudo",
        "addToValues": "Adicionar {'${variable}'} aos valores",
        "removeFromValues": "Remover {'${variable}'} dos valores",
        "addToLabels": "Adicionar {'${variable}'} aos rótulos",
        "removeFromLabels": "Remover {'${variable}'} dos rótulos",
        "resetColumns": "Redefinir Colunas",
        "expandAll": "Expandir Todos os Grupos de Linhas",
        "collapseAll": "Recolher Todos os Grupos de Linhas",
        "copy": "Copiar",
        "copyWithHeaders": "Copiar com Cabeçalhos",
        "copyWithGroupHeaders": "Copiar com Cabeçalhos de Grupo",
        "cut": "Recortar",
        "paste": "Colar",
        "export": "Exportar",
        "csvExport": "Exportar CSV",
        "excelExport": "Exportar Excel",
        "sum": "Soma",
        "first": "Primeiro",
        "last": "Último",
        "min": "Mín",
        "max": "Máx",
        "count": "Contagem",
        "avg": "Média",
        "average": "Média",
        "filteredRows": "Filtradas",
        "selectedRows": "Selecionadas",
        "totalRows": "Total de Linhas",
        "totalAndFilteredRows": "Linhas"
      },
      "noFilterMessage": "Nenhum filtro para este relatório",
      "noAccessReport": "Você não tem acesso para visualizar este relatório. Entre em contato com o administrador do sistema se achar que isso é um erro.",
      "pdfSizeErrorMessage": "O tamanho do PDF é muito grande e não pode ser exibido.",
      "pdfMaxSizeDownloaded": "O relatório é muito grande para ser exibido. Verifique sua pasta de downloads.",
      "failedLoadReports": "Falha ao carregar relatórios. Outros recursos funcionarão normalmente. Por favor, atualize a página ou entre em contato com o administrador do sistema se o problema persistir.",
      "run": "Executar",
      "download": "Baixar",
      "viewFilter": {
        "button": "Ver Filtros...",
        "title": "Parâmetros",
        "name": "Nome",
        "value": "Valor"
      },
      "fullScreen": "Tela Cheia...",
      "smallScreen": "Tela Pequena...",
      "tabButton": {
        "fullScreen": "Ocultar seção de parâmetros",
        "smallScreen": "Mostrar seção de parâmetros",
        "about": "Sobre",
        "downloadExcel": "Baixar arquivo de Planilha",
        "clear": "Fechar Todas as Abas"
      },
      "modalAbout": {
        "title": "Sobre",
        "description": "Descrição",
        "version": "Versão",
        "reference": "Referência",
        "lastChange": "Última Alteração",
        "dataSource": "Fonte de Dados"
      }
    },
    "maintenance": {
      "menuName": "Relatórios",
      "pageTitle": "Relatórios",
      "id": "ID",
      "title": "Título",
      "reference": "Referência",
      "directoryTree": "Árvore de Diretórios",
      "directoryTreeHelp": "Use barra invertida para separar pastas, ex. Relatórios\\Financeiro\\Mensal",
      "reportType": "Tipo de Relatório",
      "typeGrid": "Grade",
      "typeForm": "Formulário",
      "securityResource": "Recurso de Segurança",
      "description": "Descrição",
      "versionNumber": "Versão",
      "isActive": "Ativo",
      "lastModified": "Última Modificação",
      "isSchedulable": "Agendável",
      "isArchivable": "Arquivável",
      "isAuditable": "Auditável",
      "passMultiValue": "Passar Multivalor como String",
      "expireInDays": "Expirar em Dias",
      "add": "Adicionar Relatório",
      "edit": "Editar Relatório",
      "delete": {
        "title": "Excluir Relatório",
        "text": "Tem certeza de que deseja excluir \"{name}\"?"
      },
      "messages": {
        "created": "Relatório criado com sucesso.",
        "updated": "Relatório salvo com sucesso.",
        "deleted": "Relatório excluído com sucesso.",
        "imported": "Relatório importado com sucesso."
      },
      "sections": {
        "main": "Propriedades Principais",
        "parameters": "Parâmetros",
        "sqls": "Instruções SQL",
        "grids": "Grades de Resultado",
        "models": "Modelos de Relatório"
      },
      "sql": {
        "add": "Adicionar Instrução SQL",
        "edit": "Editar Instrução SQL",
        "description": "Descrição",
        "connection": "Conexão",
        "multipleResultset": "Múltiplos Conjuntos de Resultados",
        "sql": "SQL",
        "generateGrids": "Gerar Grades a partir de SQL",
        "generateGridsSuccess": "Grade gerada com sucesso. Revise-a na aba Grades de Resultado.",
        "delete": {
          "title": "Excluir Instrução SQL",
          "text": "Tem certeza de que deseja excluir \"{name}\"?"
        }
      },
      "grid": {
        "add": "Adicionar Grade",
        "edit": "Editar Grade",
        "label": "Rótulo",
        "resultsetNumber": "N° do Conjunto de Resultados",
        "parentGrid": "Grade Pai",
        "defaultGroupedColumns": "Colunas Agrupadas Padrão",
        "relationString": "String de Relação",
        "delete": {
          "title": "Excluir Grade",
          "text": "Tem certeza de que deseja excluir \"{name}\"?"
        }
      },
      "column": {
        "add": "Adicionar Coluna",
        "edit": "Editar Coluna",
        "columnName": "Nome da Coluna",
        "label": "Rótulo",
        "header": "Cabeçalho",
        "dataType": "Tipo de Dado",
        "sumarizeType": "Sumarizar",
        "showOrder": "Ordem",
        "mask": "Máscara",
        "helpText": "Texto de Ajuda",
        "template": "Modelo",
        "delete": {
          "title": "Excluir Coluna",
          "text": "Tem certeza de que deseja excluir \"{name}\"?"
        }
      },
      "param": {
        "add": "Adicionar Parâmetro",
        "edit": "Editar Parâmetro",
        "displayOrder": "Ordem",
        "name": "Nome",
        "nameValidation": "Apenas letras, números e underscores são permitidos.",
        "label": "Rótulo",
        "dataType": "Tipo de Dado",
        "defaultValue": "Valor Padrão",
        "helpText": "Texto de Ajuda",
        "required": "Obrigatório",
        "multiple": "Múltiplos Valores",
        "width": "Largura (colunas)",
        "enumValues": "Valores (separados por ponto e vírgula)",
        "enumValuesHelp": "ex. 1;2;3",
        "enumLabels": "Rótulos (separados por ponto e vírgula)",
        "enumLabelsHelp": "ex. Opção A;Opção B;Opção C",
        "sql": "Consulta SQL",
        "generate": "Gerar parâmetros a partir de SQL",
        "delete": {
          "title": "Excluir Parâmetro",
          "text": "Tem certeza de que deseja excluir \"{name}\"?"
        }
      },
      "model": {
        "add": "Adicionar Modelo",
        "edit": "Editar Modelo",
        "description": "Descrição",
        "order": "Ordem",
        "connection": "Conexão",
        "file": "Arquivo de Modelo (.trdx / .trdp)",
        "fileLoaded": "Arquivo carregado com sucesso.",
        "delete": {
          "title": "Excluir Modelo",
          "text": "Tem certeza de que deseja excluir \"{name}\"?"
        }
      },
      "paramDataType": {
        "text": "Texto",
        "number": "Número",
        "date": "Data",
        "time": "Hora",
        "combo": "Combo",
        "boolean": "Booleano",
        "sql": "SQL"
      },
      "colDataType": {
        "text": "Texto",
        "number": "Número",
        "date": "Data",
        "time": "Hora",
        "combo": "Combo",
        "boolean": "Booleano"
      },
      "sumarizeType": {
        "nosumarize": "Nenhum",
        "sum": "Soma",
        "min": "Mín",
        "max": "Máx",
        "average": "Média",
        "count": "Contagem"
      },
      "import": {
        "connection": "Substituição de Conexão",
        "connectionHelp": "Opcional: substituir todas as referências de conexão no arquivo importado."
      }
    }
  },
  "file": {
    "description": "Descrição",
    "files": "Arquivos",
    "editDescription": "Editar Descrição",
    "delete": "Excluir Arquivo",
    "download": "Baixar Arquivo",
    "pendingUpload": "Upload pendente. O arquivo só será salvo após clicar em 'Salvar'.",
    "noFiles": "Nenhum arquivo adicionado."
  },
  "dashboard": {
    "menuTitle": "Painel",
    "title": "Painel",
    "addWidget": "Adicionar Widget",
    "editLayout": "Editar Layout",
    "saveLayout": "Salvar Layout",
    "importLayout": "Importar Layout",
    "exportLayout": "Exportar Layout",
    "category": "Categoria",
    "widget": "Widget",
    "widgetTitle": "Título",
    "widgetParameters": "Parâmetros",
    "widgetInformation": "Informações do Widget",
    "noParameters": "Este widget não possui parâmetros.",
    "delete": "Excluir Widget",
    "viewLink": "visualizar",
    "noItemsToDisplay": "Nenhum item para exibir",
    "messages": {
      "saveSuccess": "Layout salvo com sucesso.",
      "importSuccess": "Layout importado com sucesso.",
      "exportSuccess": "Layout exportado com sucesso.",
      "importFailed": "Falha ao importar layout.",
      "widgetNotFound": "Widget não encontrado",
      "failedToLoad": "Falha ao carregar",
      "noDataAvailable": "Nenhum dado disponível",
      "noParametersConfigured": "Nenhum parâmetro configurado para este widget."
    },
    "tutorial": {
      "mainMessage": "Bem-vindo ao seu painel! Use os botões acima para personalizá-lo.",
      "callToAction": "Mostre-me como!",
      "instructions": {
        "add": {
          "title": "Botão Adicionar Widget",
          "description": "Aqui você poderá encontrar widgets por categoria. Alguns deles podem ter parâmetros para permitir um dashboard totalmente personalizável. Não se esqueça de clicar em SALVAR após adicionar todos os seus widgets."
        },
        "edit": {
          "title": "Botão Editar Layout do Widget",
          "description": "Aqui você poderá alterar seu dashboard: Adicionar ou remover widgets, movê-los e redimensioná-los. Não se esqueça de salvar após editar."
        },
        "import": {
          "title": "Botão Importar Layout",
          "description": "Com um arquivo de backup, aqui você pode importá-lo. Nota: Seu dashboard será substituído."
        },
        "export": {
          "title": "Botão Exportar Layout",
          "description": "Uma vez que seu dashboard estiver completo, você pode exportá-lo para ter um backup OU enviá-lo para outro usuário copiar seu dashboard."
        }
      }
    }
  },
  "communication": {
    "title": "Comunicados",
    "menuTitle": "Comunicados",
    "menuName": "Comunicados",
    "inbox": "Caixa de Entrada",
    "markAsRead": "Marcar como Lido",
    "subject": "Assunto",
    "date": "Data",
    "priority": "Prioridade",
    "backToInbox": "Voltar para a Caixa de Entrada",
    "noMessages": "Nenhuma mensagem na sua caixa de entrada.",
    "status": "Status",
    "read": "Lido",
    "unread": "Não Lido",
    "edit": "Visualizar",
    "messages": {
      "markedAsRead": "Comunicado confirmado"
    }
  },
  "settings": {
    "title": "Configurações",
    "theme": {
      "name": "Tema",
      "dark": "Escuro",
      "light": "Claro"
    }
  },
  "userInfo": {
    "title": "Informações do Usuário",
    "permissions": "Permissões",
    "userName": "Nome de Usuário",
    "fullName": "Nome Completo",
    "email": "E-mail",
    "employeeId": "ID do Funcionário",
    "action": "Ação",
    "permissionCode": "Código de Permissão"
  },
  "profile": {
    "title": "Meu Perfil",
    "menuName": "Perfil",
    "score": "Pontuação do Perfil",
    "managerWarning": "A informação fornecida na página \"Meu Perfil\" é acessível aos Gestores e RH da organização para fins de Mapeamento de Talentos.",
    "photo": "Mudar imagem",
    "name": "Nome",
    "email": "E-mail",
    "manager": "Gestor",
    "position": "Função",
    "plant": "Planta",
    "businessArea": "Área de Negócio",
    "degreeType": "Formação",
    "degreeName": "Nome do Diploma ou Certificado",
    "language": "Idiomas",
    "languagesInfo": "Selecione todos os idiomas que você fala",
    "geoMobility": {
      "label": "Mobilidade Geográfica",
      "none": "Nenhum",
      "local": "Local",
      "national": "Nacional",
      "international": "Internacional",
      "nationalAndInternational": "Nacional e Internacional"
    },
    "businessMobility": "Mobilidade Geográfica",
    "skills": "Minhas Habilidades",
    "skillsInfo": "Selecione suas áreas de especialização",
    "careerInterests": "Interesses Profissionais",
    "careerAspirations": "Aspirações de Carreira",
    "jobHistory": "Histórico de Cargo",
    "save": "Salvar",
    "invalidPhotoFormat": "Imagem com uma extensão inválida",
    "photoCrop": {
      "title": "Foto de perfil",
      "selectImage": "Enviar",
      "confirm": "Aplicar",
      "cancel": "Cancelar",
      "deletePhoto": "Remover",
      "hint": "Arraste para reposicionar. Belisque ou role para ampliar.",
      "emptyState": "Nenhuma imagem selecionada. Clique em \"Enviar\" para começar."
    },
    "messages": {
      "saved": "Perfil salvo com sucesso",
      "notRegistered": "Você não está registrado no JTP. Entre em contato com o RH para ser adicionado. Até lá, seu acesso será restrito."
    }
  },
  "impersonate": {
    "title": "Personificar Usuário",
    "userName": "Login",
    "start": "Iniciar Personificação",
    "messages": {
      "impersonationStarted": "Sessão de personificação iniciada. Para retornar à sua conta, faça logout e login novamente.",
      "userNotFound": "Usuário não encontrado. Por favor, verifique o nome de usuário e tente novamente."
    }
  },
  "about": {
    "menuName": "Sobre",
    "title": "Sobre"
  },
  "releaseNotes": {
    "menuName": "Notas de Lançamento",
    "title": "Notas de Lançamento",
    "name": "Nome",
    "version": "Versão",
    "description": "Descrição",
    "appType": "Tipo de Aplicação",
    "releaseDate": "Data de Lançamento",
    "messages": {
      "notFound": "Nota de lançamento não encontrada.",
      "saveError": "Erro ao salvar nota de lançamento. Por favor, tente novamente mais tarde."
    }
  },
  "help": {
    "menuTitle": "Ajuda",
    "externalLinkMessage": "Você está prestes a abrir um link externo:",
    "externalLinkConfirm": "Abrir link",
    "lastUpdated": "Última atualização: {date}",
    "wasThisHelpful": "Isto foi útil?",
    "helpful": "Útil",
    "notHelpful": "Não foi útil",
    "pageModal": {
      "title": "Ajuda desta página",
      "intro": "Os artigos de ajuda mostram orientações para a página em que você está. Selecione um para abri-lo ou feche esta janela."
    }
  },
  "admin": {
    "menuTitle": "Administração",
    "appCustomizations": {
      "menuName": "Personalizações do App",
      "pageTitle": "Personalizações do App",
      "imageLogos": "Logotipos de Imagem",
      "headerLogo": "Logotipo do Cabeçalho",
      "menuLogo": "Logotipo do Menu",
      "bannerImage": "Imagem de Banner",
      "upload": "Enviar",
      "remove": "Remover",
      "noCustom": "Imagem padrão",
      "preview": "Prévia",
      "messages": {
        "saved": "Personalizações salvas com sucesso.",
        "invalidKey": "Chave de logotipo inválida.",
        "invalidLanguage": "Código de idioma inválido.",
        "fileRequired": "O arquivo é obrigatório.",
        "fileTooLarge": "O arquivo excede o tamanho máximo permitido de 2 MB.",
        "fileTypeNotAllowed": "Tipo de arquivo não permitido. Use PNG, JPEG ou WebP.",
        "notFound": "Personalização não encontrada."
      }
    },
    "help": {
      "menuName": "Ajuda",
      "pageTitle": "Ajuda",
      "title": "Título",
      "description": "Descrição",
      "isActive": "Ativo",
      "displayOrder": "Ordem de Exibição",
      "securityResources": "Recursos de Segurança",
      "securityResourcesInfo": "Lista de permissões separadas por vírgula. Deixe vazio para tornar visível a todos; caso contrário, o usuário deve ter pelo menos uma das permissões informadas.",
      "isMenuDisplayed": "Mostrar no Menu",
      "isMenuDisplayedInfo": "Quando desativado, esta ajuda fica oculta no menu de Ajuda, mas ainda pode ser aberta pelo ícone de ajuda nas páginas associadas.",
      "isTrackingEnabled": "Ativar Rastreamento",
      "isTrackingEnabledInfo": "Quando ativado, as visualizações são registradas por funcionário e uma avaliação \"isto foi útil\" é exibida na página de ajuda.",
      "viewCount": "Visualizações",
      "viewCountValue": "Visto {views} vezes por {viewers} pessoas",
      "viewCountInfo": "Número total de visualizações e a quantidade de funcionários distintos que abriram esta ajuda.",
      "helpfulCount": "Útil",
      "notHelpfulCount": "Não foi útil",
      "associatedMenus": "Páginas Associadas",
      "associatedMenusInfo": "Vincule esta ajuda a uma ou mais páginas para que possa ser aberta diretamente pelo ícone de ajuda nessas páginas.",
      "addMenu": "Adicionar página",
      "add": "Adicionar Ajuda",
      "edit": "Editar Ajuda",
      "delete": {
        "title": "Excluir Ajuda",
        "text": "Tem certeza de que deseja excluir esta entrada de ajuda?"
      },
      "messages": {
        "created": "Ajuda criada com sucesso.",
        "updated": "Ajuda atualizada com sucesso.",
        "deleted": "Ajuda excluída com sucesso.",
        "notFound": "Ajuda não encontrada."
      }
    },
    "menuHierarchy": {
      "menuName": "Hierarquia do Menu",
      "pageTitle": "Hierarquia do Menu",
      "displayName": "Nome de Exibição",
      "route": "Rota",
      "routeParam": "Parâmetro do Menu",
      "securityResources": "Recursos de Segurança",
      "children": "Sub-Menus",
      "isActive": "Está Ativo",
      "icon": "Ícone",
      "iconHelpText": "Biblioteca de ícones",
      "displayOrder": "Ordem de Exibição",
      "edit": "Editar Item do Menu",
      "messages": {
        "success": "Item do menu salvo com sucesso."
      }
    },
    "notificationTemplate": {
      "menuName": "Modelo de Notificação",
      "pageTitle": "Modelo de Notificação",
      "name": "Nome",
      "parent": "Modelo Pai",
      "parentInfo": "Apenas modelos que começam com masterTemplate podem ser usados como modelo pai.",
      "pushNotificationEnabled": "Notificação Push Habilitada",
      "pushRoute": "Rota de Notificação Push",
      "sqlQuery": "Consulta SQL",
      "sqlQueryDateFormatInfo": "Colunas de data devem ser formatadas no formato MM/dd/yyyy.",
      "generalSection": "Informações Gerais",
      "emailSection": "Notificação por E-mail",
      "emailSubject": "Assunto do E-mail",
      "emailBody": "Corpo do E-mail (HTML)",
      "pushSection": "Notificação Push",
      "pushSubject": "Assunto Push",
      "pushBody": "Corpo Push",
      "overrideNotificationTemplate": "Sobrescrever Modelo de Notificação",
      "add": "Adicionar Modelo",
      "edit": "Editar Modelo",
      "delete": {
        "title": "Excluir Modelo",
        "text": "Tem certeza de que deseja excluir o modelo \"{name}\"?"
      },
      "attachment": {
        "title": "Anexar Arquivo",
        "attachment": "Arquivo Anexado",
        "attach": "Anexar",
        "noAttachment": "Nenhum arquivo anexado...",
        "messages": {
          "uploadedSuccessfully": "Arquivo anexado com sucesso."
        },
        "delete": {
          "title": "Excluir Anexo",
          "text": "Tem certeza de que deseja excluir o anexo \"{name}\"?"
        }
      },
      "messages": {
        "created": "Modelo de notificação criado com sucesso.",
        "updated": "Modelo de notificação atualizado com sucesso.",
        "deleted": "Modelo de notificação excluído com sucesso.",
        "alreadyExists": "Um modelo de notificação com este nome já existe.",
        "fileRequired": "O arquivo é obrigatório.",
        "importError": "Ocorreu um erro ao importar o modelo de notificação.",
        "notFound": "Modelo de notificação não encontrado."
      }
    },
    "department": {
      "menuName": "Departamento",
      "pageTitle": "Departamento",
      "name": "Nome",
      "isActive": "Está Ativo",
      "add": "Adicionar Departamento",
      "edit": "Editar Departamento",
      "delete": {
        "title": "Excluir Departamento",
        "text": "Tem certeza de que deseja excluir este departamento?"
      },
      "messages": {
        "created": "Departamento criado com sucesso.",
        "updated": "Departamento atualizado com sucesso.",
        "deleted": "Departamento excluído com sucesso."
      }
    },
    "businessArea": {
      "menuName": "Área de Negócio",
      "pageTitle": "Área de Negócio",
      "id": "Id",
      "externalId": "Id Externo",
      "description": "Descrição",
      "calendarId": "Calendário",
      "isActive": "Está Ativo",
      "edit": "Editar Área de Negócio",
      "messages": {
        "created": "Área de Negócio criada com sucesso.",
        "updated": "Área de Negócio atualizada com sucesso.",
        "deleted": "Área de Negócio excluída com sucesso."
      }
    },
    "businessUnit": {
      "menuName": "Unidade de Negócio",
      "pageTitle": "Unidade de Negócio",
      "id": "Id",
      "externalId": "Id Externo",
      "description": "Descrição",
      "isActive": "Ativa",
      "edit": "Editar Unidade de Negócio",
      "messages": {
        "created": "Unidade de Negócio criada com sucesso.",
        "updated": "Unidade de Negócio atualizada com sucesso.",
        "deleted": "Unidade de Negócio excluída com sucesso.",
        "inUse": "O registro da Unidade de Negócio está em uso. Exclua as dependências primeiro.",
        "notFound": "Registro da Unidade de Negócio não encontrado"
      },
      "add": "Adicionar Unidade de Negócio",
      "delete": {
        "title": "Excluir Unidade de Negócio",
        "text": "Tem certeza de que deseja excluir esta Unidade de Negócio?"
      }
    },
    "division": {
      "menuName": "Divisão",
      "pageTitle": "Divisão",
      "id": "Id",
      "externalId": "Id Externo",
      "description": "Descrição",
      "isActive": "Ativa",
      "businessUnitId": "Unidade de Negócio",
      "edit": "Editar Divisão",
      "messages": {
        "created": "Divisão criada com sucesso.",
        "updated": "Divisão atualizada com sucesso.",
        "deleted": "Divisão excluída com sucesso."
      },
      "add": "Adicionar Divisão",
      "delete": {
        "title": "Excluir Divisão",
        "text": "Tem certeza de que deseja excluir esta Divisão?"
      }
    },
    "organization": {
      "menuName": "Organização",
      "pageTitle": "Organização",
      "id": "ID",
      "externalId": "ID Externo",
      "name": "Nome",
      "plantAreaId": "Área da Planta",
      "organizationParentId": "Organização Pai",
      "edit": "Editar Organização",
      "messages": {
        "created": "Organização criada com sucesso.",
        "updated": "Organização atualizada com sucesso.",
        "deleted": "Organização excluída com sucesso."
      },
      "add": "Adicionar Organização",
      "delete": {
        "title": "Excluir Organização",
        "text": "Tem certeza de que deseja excluir esta organização?"
      }
    },
    "plant": {
      "menuName": "Planta",
      "pageTitle": "Planta",
      "id": "Id",
      "name": "Nome",
      "alias": "Apelido",
      "isActive": "Está Ativa",
      "divisionId": "Divisão",
      "countryId": "País",
      "employeeCanUpdateGoals": "Funcionário pode atualizar metas",
      "employeeCanUpdateTracks": "Funcionário pode atualizar resultados",
      "employeeCanIncludeKPI": "Funcionário pode criar KPI",
      "managerCanUpdateGoals": "Gerente pode atualizar metas",
      "managerCanUpdateTracks": "Gerente pode atualizar resultados",
      "managerCanIncludeKPI": "Gerente pode criar KPI",
      "edit": "Editar Planta",
      "messages": {
        "created": "Planta criada com sucesso.",
        "updated": "Planta atualizada com sucesso.",
        "deleted": "Planta excluída com sucesso.",
        "inUse": "O registro da Planta está em uso. Exclua primeiro seus vínculos.",
        "notFound": "Registro de Planta não encontrado"
      },
      "add": "Adicionar Planta",
      "delete": {
        "title": "Excluir Planta",
        "text": "Tem certeza que deseja excluir esta Planta?"
      }
    },
    "personnelArea": {
      "menuName": "Área de Pessoal",
      "pageTitle": "Área de Pessoal",
      "id": "Id",
      "description": "Descrição",
      "externalId": "Id Externo",
      "plantId": "Planta",
      "isActive": "Ativo",
      "sourceModifiedDate": "Data de Modificação da Fonte",
      "edit": "Editar Área de Pessoal",
      "messages": {
        "created": "Área de Pessoal criada com sucesso.",
        "updated": "Área de Pessoal atualizada com sucesso.",
        "deleted": "Área de Pessoal excluída com sucesso.",
        "inUse": "O registro de Área de Pessoal está em uso. Exclua seus usos primeiro.",
        "notFound": "Registro de Área de Pessoal não encontrado",
        "alreadyExists": "Já existe uma área de pessoal com esta descrição.",
        "fileRequired": "O arquivo é obrigatório.",
        "importError": "Ocorreu um erro ao importar a área de pessoal.",
        "invalidPlant": "Id de Planta inválido",
        "duplicateExternalId": "Id Externo duplicado",
        "importSuccess": "Área de Pessoal importada com sucesso. Você receberá o arquivo por e-mail",
        "exportSuccess": "Área de Pessoal exportada com sucesso. Você receberá o arquivo por e-mail",
        "exportFailed": "Falha ao exportar a área de pessoal.",
        "importFailed": "Falha ao importar a área de pessoal.",
        "personNotFound": "Pessoa não encontrada para realizar a importação. Contate o Administrador.",
        "emailNotFound": "E-mail não encontrado para realizar a importação. Contate o Administrador.",
        "importFalied": "A importação da área de pessoal falhou."
      },
      "add": "Adicionar Área de Pessoal",
      "delete": {
        "title": "Excluir Área de Pessoal",
        "text": "Tem certeza de que deseja excluir esta Área de Pessoal?"
      }
    },
    "position": {
      "menuName": "Posição",
      "pageTitle": "Posição",
      "id": "Id",
      "description": "Descrição",
      "externalId": "Id Externo",
      "active": "Ativo",
      "jobCode": "Cargo",
      "jobId": "Cargo",
      "organizationId": "Organização",
      "employeeSubGroupId": "Subgrupo de Funcionários",
      "costCenterId": "Centro de Custo",
      "salaryLevelId": "Nível Salarial",
      "businessAreaId": "Área de Negócio",
      "bonusFrequencyId": "Frequência de Bônus",
      "personnelAreaCode": "Área de Pessoal",
      "payGradeType": "Tipo de Faixa Salarial",
      "payGradeArea": "Área de Faixa Salarial",
      "employeeGroupId": "Grupo de Funcionários",
      "salaryGroupId": "Grupo Salarial",
      "minimum": "Mínimo",
      "midpoint": "Ponto Médio",
      "edit": "Editar Área de Posição",
      "messages": {
        "created": "Posição criada com sucesso.",
        "updated": "Posição atualizada com sucesso.",
        "inUse": "O registro de posição está em uso. Exclua seus usos primeiro.",
        "notFound": "Registro de posição não encontrado"
      },
      "add": "Adicionar Posição"
    },
    "positionProfile": {
      "pageTitle": "Posição Crítica",
      "globalCritical": "Crítico Global",
      "countryCritical": "Crítico por País",
      "businessUnitCritical": "Crítico por Unidade de Negócio",
      "positionType": "Tipo de Posição",
      "sucessorType": "Tipo de Sucessor",
      "potentialSuccessorType": "Tipo de Sucessor",
      "potentialSuccessorId": "Sucessor Potencial",
      "readinessFactor": "Fator de Prontidão",
      "potentialSuccessorName": "Nome",
      "potentialSuccessorCompany": "Empresa",
      "potentialSuccessorLinkedIn": "URL do LinkedIn",
      "potentialSuccessorNotes": "Notas",
      "messages": {
        "created": "Posição crítica criada com sucesso.",
        "updated": "Posição crítica atualizada com sucesso."
      }
    },
    "configuration": {
      "menuName": "Configuração",
      "pageTitle": "Configuração",
      "key": "Chave",
      "value": "Valor",
      "editorType": "Tipo",
      "add": "Adicionar Configuração",
      "edit": "Editar Configuração",
      "delete": {
        "title": "Excluir Configuração",
        "text": "Tem certeza de que deseja excluir esta configuração?"
      },
      "messages": {
        "created": "Configuração criada com sucesso.",
        "updated": "Configuração atualizada com sucesso.",
        "deleted": "Configuração excluída com sucesso."
      },
      "types": {
        "text": "Texto",
        "string": "String",
        "number": "Número",
        "int": "Inteiro",
        "boolean": "Booleano"
      }
    },
    "widget": {
      "menuName": "Widget",
      "pageTitle": "Widget",
      "name": "Nome",
      "description": "Descrição",
      "securityResources": "Recursos de Segurança",
      "link": "Link",
      "query": "Consulta SQL",
      "queryRequired": "Consulta SQL é obrigatória.",
      "sqlQueryDateFormatInfo": "Colunas de data devem ser formatadas no formato MM/dd/yyyy.",
      "minHeight": "Altura Mínima",
      "minWidth": "Largura Mínima",
      "autoApplied": "Aplicar a todos os painéis",
      "autoAppliedHelp": "Isso forçará este widget em todos os painéis, e os usuários continuarão a vê-lo mesmo que tentem removê-lo.",
      "type": "Tipo",
      "category": "Categoria",
      "add": "Adicionar Widget",
      "edit": "Editar Widget",
      "delete": {
        "title": "Excluir Widget",
        "text": "Tem certeza de que deseja excluir este widget?"
      },
      "examples": {
        "viewSQLExamples": "Ver exemplos de SQL",
        "general": "Geral",
        "generalDescription": "Por padrão, o sistema fornece os seguintes parâmetros, que podem ser referenciados diretamente em qualquer consulta SQL de widget.",
        "loggedUserNameDescription": "Nome de usuário de login do usuário atualmente logado (por exemplo: {email}).",
        "loggedUserEmployeeIdDescription": "Identificador do funcionário do usuário atualmente logado.",
        "loggedUserLanguageDescription": "Código do idioma do usuário atualmente logado (por exemplo: en-US, pt-BR).",
        "loggedUserUniqueIdDescription": "Id único do usuário (Guid)",
        "loggedUserEncryptedUniqueIdDescription": "Id único criptografado do usuário",
        "listDescription": "Cada linha representa um item da lista.",
        "numberDescription": "Retorna um único valor numérico.",
        "donutDescription": "Rótulos e valores devem estar alinhados por posição.",
        "lineDescription": "Cada linha representa uma série de linha."
      },
      "messages": {
        "created": "Widget criado com sucesso.",
        "updated": "Widget atualizado com sucesso.",
        "deleted": "Widget excluído com sucesso.",
        "fileRequired": "O arquivo é obrigatório.",
        "importError": "Ocorreu um erro ao importar o widget.",
        "queryVariablesMissing": "As seguintes variáveis estão faltando na consulta do widget: \"{variables}\". Por favor, adicione-as à consulta para garantir o funcionamento correto."
      }
    },
    "widgetCategory": {
      "menuName": "Categoria de Widget",
      "pageTitle": "Categoria de Widget",
      "name": "Nome",
      "description": "Descrição",
      "type": "Tipo",
      "add": "Adicionar Categoria de Widget",
      "edit": "Editar Categoria de Widget",
      "delete": {
        "title": "Excluir Categoria de Widget",
        "text": "Tem certeza de que deseja excluir esta categoria de widget?"
      },
      "messages": {
        "created": "Categoria de Widget criada com sucesso.",
        "updated": "Categoria de Widget atualizada com sucesso.",
        "deleted": "Categoria de Widget excluída com sucesso."
      }
    },
    "widgetType": {
      "menuName": "Tipo de Widget",
      "pageTitle": "Tipo de Widget",
      "name": "Nome",
      "types": {
        "number": "Número",
        "list": "Lista",
        "donut": "Rosca",
        "line": "Linha"
      }
    },
    "widgetParameter": {
      "menuName": "Parâmetro de Widget",
      "menuTitle": "Parâmetro de Widget",
      "title": "Parâmetro de Widget",
      "name": "Nome",
      "nameInfo": "Nome usado para identificar o parâmetro na consulta SQL do widget. Não use espaços ou caracteres especiais.",
      "nameUniqueError": "Um Parâmetro de Widget com este nome já existe.",
      "description": "Descrição",
      "isRequired": "É Obrigatório?",
      "isMultiple": "É Múltiplo?",
      "status": "Status",
      "edit": "Editar Parâmetro de Widget",
      "add": "Adicionar Parâmetro de Widget",
      "type": "Tipo",
      "data": "Consulta SQL",
      "dataInfo": "A consulta SQL deve retornar duas colunas chamadas 'Value' e 'Text'.",
      "listOfValues": "Lista de Valores",
      "addValue": "Adicionar Valor",
      "value": "Valor",
      "label": "Rótulo",
      "delete": {
        "title": "Excluir Parâmetro de Widget",
        "text": "Tem certeza de que deseja excluir {name}?"
      },
      "types": {
        "text": "Texto",
        "number": "Número",
        "date": "Data",
        "boolean": "Booleano",
        "select": "Lista",
        "sql": "Lista de Consulta"
      },
      "messages": {
        "notFound": "Parâmetro de Widget não encontrado.",
        "saveSuccess": "Parâmetro de Widget salvo com sucesso.",
        "saveError": "Ocorreu um erro ao salvar o Parâmetro de Widget.",
        "deleteSuccess": "Parâmetro de Widget excluído com sucesso.",
        "deleteError": "Ocorreu um erro ao excluir o Parâmetro de Widget.",
        "isInUse": "Não é possível excluir o Parâmetro de Widget porque está em uso."
      }
    },
    "people": {
      "menuName": "Pessoas",
      "pageTitle": "Pessoas",
      "edit": "Editar Pessoa",
      "employeeId": "ID do Funcionário",
      "person": "Pessoa",
      "id": "Id",
      "name": "Nome",
      "email": "E-mail",
      "externalId": "ID Externo",
      "status": "Status",
      "type": "Tipo",
      "positionShortDescription": "Breve descrição da posição",
      "hireDate": "Data de Admissão",
      "culture": "Cultura",
      "sourceJTPInstance": "Código JTP de Origem",
      "documentId": "ID do Documento",
      "manager": "Gestor",
      "position": "Cargo",
      "bonusFrequency": "Frequência de Bônus",
      "businessArea": "Área de Negócio",
      "personnelArea": "Área de Pessoal",
      "division": "Divisão",
      "plant": "Planta",
      "businessUnit": "Unidade de Negócio",
      "shiftId": "Turno",
      "plantAreaId": "Área da Planta",
      "immigrationTypeId": "Tipo de Imigração",
      "customerSpecificStatus": "Status Específico do Cliente",
      "vendorNumber": "Número do Fornecedor",
      "accountNumber": "Últimos 4 Dígitos da Conta",
      "overrideManagerId": "Gestor Substituto",
      "saipAllocation": "Alocação SAIP",
      "requirePrivacyConsent": "Funcionário Global",
      "globalDirectReports": "Subordinados Diretos Globais",
      "globalManagerOverrideHelpText": "Os funcionários selecionados reportarão a este funcionário apenas em escala global. Se este funcionário possuir subordinados diretos, todos serão marcados como globais também.",
      "messages": {
        "updated": "Pessoa atualizada com sucesso.",
        "notFound": "Registro de pessoa não encontrado.",
        "alreadyExists": "Já existe uma pessoa com esta descrição.",
        "fileRequired": "O arquivo é obrigatório.",
        "importError": "Ocorreu um erro ao importar as pessoas.",
        "importSuccess": "Pessoas importadas com sucesso. Você receberá o arquivo por e-mail.",
        "importFailed": "Falha ao importar pessoas.",
        "personNotFound": "Pessoa não encontrada para realizar a importação. Contate o Administrador.",
        "emailNotFound": "E-mail não encontrado para realizar a importação. Contate o Administrador.",
        "importFalied": "A importação de pessoas falhou."
      },
      "personTypes": {
        "unknown": "Desconhecido",
        "salariedEmployee": "Funcionário Assalariado",
        "contractor": "Contratado",
        "vendor": "Fornecedor",
        "hourlyEmployee": "Funcionário Horista",
        "external": "Externo",
        "duHourlyInactive": "DU Horista Inativo",
        "duSalariedInactive": "DU Assalariado Inativo",
        "duTruckDriverIn": "DU Motorista de Caminhão Em",
        "executive": "Executivo",
        "union": "Sindicalizado",
        "nonUnion": "Não Sindicalizado",
        "unionPossible": "Sindicalização Possível",
        "salariedNonExempt": "Assalariado Não Isento",
        "hourly": "Horista",
        "duPaidLeave": "DU Licença Remunerada",
        "truckDriver": "Motorista de Caminhão",
        "duUnpaidLeave": "DU Licença Não Remunerada",
        "workRelease": "Liberação de Trabalho",
        "externalAccessLevelOne": "Acesso Externo Nível Um",
        "externalAccessLevelTwo": "Acesso Externo Nível Dois",
        "externalAccessLevelThree": "Acesso Externo Nível Três",
        "externalAccessLevelFour": "Acesso Externo Nível Quatro",
        "externalAccessLevelFive": "Acesso Externo Nível Cinco",
        "globalEmployee": "Funcionário Global"
      },
      "customerSpecificStatuses": {
        "unknown": "Desconhecido",
        "active": "Ativo",
        "inactive": "Inativo",
        "incomeAssistance": "Auxílio de Renda",
        "lOA": "LOA",
        "retiree": "Aposentado",
        "withdrawn": "Afastado"
      }
    },
    "reportColumnTemplate": {
      "menuName": "Modelos de Coluna de Relatório",
      "pageTitle": "Modelos de Coluna de Relatório",
      "id": "ID",
      "description": "Descrição",
      "template": "Modelo",
      "templateHelp": "Use {value} como placeholder para o valor da célula. HTML é suportado.",
      "add": "Adicionar Modelo",
      "edit": "Editar Modelo",
      "delete": {
        "title": "Excluir Modelo",
        "text": "Tem certeza de que deseja excluir \"{name}\"?"
      },
      "messages": {
        "created": "Modelo criado com sucesso.",
        "updated": "Modelo atualizado com sucesso.",
        "deleted": "Modelo excluído com sucesso."
      }
    },
    "companyCode": {
      "menuName": "Códigos de Empresa"
    },
    "costCenter": {
      "menuName": "Centros de Custo"
    },
    "currency": {
      "menuName": "Moedas"
    },
    "exchangeRate": {
      "menuName": "Taxas de Câmbio"
    }
  },
  "threeHundredSixty": {
    "menuTitle": "360",
    "questionOption": {
      "menuTitle": "Escalas de Classificação",
      "pageTitle": "Escalas de Classificação",
      "description": "Descrição",
      "add": "Adicionar Escala de Classificação",
      "edit": "Editar Escala de Classificação",
      "delete": {
        "title": "Excluir Escala de Classificação",
        "text": "Tem certeza de que deseja excluir esta escala de classificação?"
      },
      "messages": {
        "notFound": "Escala de Classificação não encontrada.",
        "saveSuccess": "Escala de Classificação salva com sucesso.",
        "saveError": "Ocorreu um erro ao salvar a Escala de Classificação.",
        "deleteSuccess": "Escala de Classificação excluída com sucesso.",
        "deleteError": "Ocorreu um erro ao excluir a Escala de Classificação.",
        "isInUse": "Não é possível excluir a Escala de Classificação porque está em uso.",
        "duplicateName": "Já existe uma Escala de Classificação com esta descrição."
      },
      "options": {
        "title": "Opções",
        "value": "Valor",
        "description": "Descrição",
        "explanation": "Explicação",
        "itemOrder": "Ordem",
        "color": "Cor",
        "commentConfig": "Configuração de Comentários",
        "add": "Adicionar Opção",
        "edit": "Editar Opção",
        "delete": {
          "title": "Excluir Opção",
          "text": "Tem certeza de que deseja excluir esta opção?"
        },
        "messages": {
          "created": "Opção criada com sucesso.",
          "updated": "Opção atualizada com sucesso.",
          "deleted": "Opção excluída com sucesso.",
          "notFound": "Opção não encontrada.",
          "duplicateValue": "Duas ou mais opções possuem o mesmo valor. Cada opção deve ter um valor único.",
          "duplicateDescription": "Duas ou mais opções possuem a mesma descrição. Cada opção deve ter uma descrição única."
        },
        "commentConfigType": {
          "followForm": "Seguir Formulário",
          "required": "Obrigatório",
          "notRequired": "Não Obrigatório"
        }
      }
    },
    "questionGroup": {
      "menuTitle": "Grupos de Perguntas",
      "pageTitle": "Grupos de Perguntas",
      "name": "Nome",
      "description": "Descrição",
      "add": "Adicionar Grupo de Perguntas",
      "edit": "Editar Grupo de Perguntas",
      "delete": {
        "title": "Excluir Grupo de Perguntas",
        "text": "Tem certeza de que deseja excluir este grupo de perguntas: {name}?"
      },
      "messages": {
        "notFound": "Grupo de Perguntas não encontrado.",
        "saveSuccess": "Grupo de Perguntas salvo com sucesso.",
        "saveError": "Ocorreu um erro ao salvar o Grupo de Perguntas.",
        "deleteSuccess": "Grupo de Perguntas excluído com sucesso.",
        "deleteError": "Ocorreu um erro ao excluir o Grupo de Perguntas.",
        "isInUse": "Não é possível excluir o Grupo de Perguntas porque está em uso."
      }
    },
    "question": {
      "menuTitle": "Perguntas",
      "pageTitle": "Perguntas",
      "name": "Nome",
      "weight": "Peso",
      "commentDisabled": "Comentário Desabilitado",
      "description": "Descrição",
      "questionGroup": "Grupo de Perguntas",
      "questionOption": "Escala de Classificação",
      "add": "Adicionar Pergunta",
      "edit": "Editar Pergunta",
      "delete": {
        "title": "Excluir Pergunta",
        "text": "Tem certeza de que deseja excluir esta pergunta?"
      },
      "messages": {
        "notFound": "Pergunta não encontrada.",
        "saveSuccess": "Pergunta salva com sucesso.",
        "saveError": "Ocorreu um erro ao salvar a Pergunta.",
        "deleteSuccess": "Pergunta excluída com sucesso.",
        "deleteError": "Ocorreu um erro ao excluir a Pergunta.",
        "isInUse": "Não é possível excluir a Pergunta porque está em uso."
      }
    },
    "formCategory": {
      "menuTitle": "Categorias de Formulário",
      "pageTitle": "Categorias de Formulário",
      "name": "Nome",
      "description": "Descrição",
      "add": "Adicionar Categoria de Formulário",
      "edit": "Editar Categoria de Formulário",
      "delete": {
        "title": "Excluir Categoria de Formulário",
        "text": "Tem certeza de que deseja excluir esta categoria de formulário?"
      },
      "messages": {
        "notFound": "Categoria de Formulário não encontrada.",
        "saveSuccess": "Categoria de Formulário salva com sucesso.",
        "saveError": "Ocorreu um erro ao salvar a Categoria de Formulário.",
        "deleteSuccess": "Categoria de Formulário excluída com sucesso.",
        "deleteError": "Ocorreu um erro ao excluir a Categoria de Formulário.",
        "isInUse": "Não é possível excluir a Categoria de Formulário porque está em uso."
      }
    },
    "formDelegate": {
      "menuTitle": "Delegar Formulário",
      "pageTitle": "Delegar Formulário",
      "form": "Formulário",
      "manager": "Gestor",
      "delegate": "Delegado para",
      "add": "Adicionar",
      "edit": "Editar",
      "delegatedToPerson": "Delegar para",
      "invitedEnabled": "Permitir Convite",
      "signEnabled": "Permitir Assinatura",
      "resultViewerEnabled": "Permitir Visualizar Resultados",
      "delete": {
        "title": "Excluir Formulário Delegado",
        "text": "Tem certeza de que deseja excluir o formulário delegado?"
      },
      "messages": {
        "notFound": "Formulário Delegado não encontrado.",
        "saveSuccess": "Formulário Delegado salvo com sucesso.",
        "saveError": "Ocorreu um erro ao salvar o Formulário Delegado.",
        "deleteSuccess": "Formulário Delegado excluído com sucesso.",
        "deleteError": "Ocorreu um erro ao excluir o Formulário Delegado.",
        "managerDisabledMessage": "Você não tem acesso a este formulário delegado"
      }
    },
    "formDelegateGlobal": {
      "menuTitle": "Delegar Formulário Global",
      "pageTitle": "Delegar Formulário Global"
    },
    "form": {
      "menuTitle": "Formulários",
      "pageTitle": "Formulários",
      "id": "Id",
      "description": "Descrição",
      "category": "Categoria",
      "categoryId": "Categoria",
      "stage": {
        "label": "Estágio",
        "preparation": "Preparação",
        "execution": "Execução",
        "managerReview": "Revisão do Gestor",
        "participantReview": "Revisão do Participante",
        "closed": "Fechado"
      },
      "active": "Ativo",
      "maximumHireDate": "Data Máxima de Contratação",
      "maxPeopleEvaluateAlert": "Alerta de Máximo de Avaliações",
      "includeGlobalReporting": "Relatório Global",
      "customerSpecificStatus": "Status Específico do Cliente",
      "employeeType": "Tipo de Funcionário",
      "reportType": {
        "label": "Tipo de Relatório",
        "question": "Por Pergunta",
        "questionGroup": "Por Grupo de Perguntas"
      },
      "directReportBox": "Avaliação da Equipe",
      "selfEvaluationBox": "Autoavaliação",
      "managerEvaluationBox": "Avaliação do Gestor",
      "crossGroupEvaluationBox": "Avaliação entre Grupos",
      "freeEvaluationBox": "Avaliação Espontânea",
      "dueDatesBox": "Data de Vencimento",
      "evaluation": "Avaliação",
      "comments": "Comentários",
      "weight": "Peso",
      "minCrossGroupEvaluations": "Avaliações Mínimas Cross Group",
      "crossGroupDueDate": "Solicitar minhas avaliações",
      "evaluationDueDate": "Aprovar solicitações para minha equipe",
      "managerSignDueDate": "Limite para aprovar solicitações",
      "participantSignDueDate": "Fechamento",
      "processDueDate": "Periodo final para avaliações",
      "beginningReviewDate": "Início do Período de Revisão",
      "endingReviewDate": "Fim do Período de Revisão",
      "maxReleaseQuestionnaireDate": "Liberar Avaliação",
      "createdBy": "Criado por",
      "createdDate": "Data de Criação",
      "modifiedBy": "Modificado por",
      "modifiedDate": "Data de Modificação",
      "maximumHireDateHelpText": "Data máxima de contratação do funcionário para participar, exceto se o funcionário for um gestor.",
      "maxPeopleEvaluateAlertHelpText": "Mostre um alerta depois que o funcionário atingir o número máximo de pessoas a serem avaliadas",
      "includeGlobalReportingHelpText": "Incluir nos relatórios globais",
      "directReportEvaluationHelpText": "Avaliação da Equipe",
      "directReportCommentsHelpText": "Comentários da Equipe",
      "directReportWeightHelpText": "Peso da Equipe",
      "selfEvaluationHelpText": "Autoavaliação",
      "selfCommentsHelpText": "Comentários de Autoavaliação",
      "selfWeightHelpText": "Peso de Autoavaliação",
      "managerEvaluationHelpText": "Avaliação do Gestor",
      "managerCommentsHelpText": "Comentários do Gestor",
      "managerWeightHelpText": "Peso do Gestor",
      "freeCommentsHelpText": "Comentários Livres",
      "freeWeightHelpText": "Peso Livre",
      "crossGroupEvaluationHelpText": "Avaliação entre Grupos",
      "crossGroupCommentsHelpText": "Comentários do Cross Group",
      "crossGroupWeightHelpText": "Peso Cross Group",
      "minCrossGroupEvaluationsHelpText": "Número mínimo de avaliação entre grupos para permitir que o gestor libere as avaliações.",
      "maxReleaseQuestionnaireDateHelpText": "Data máxima para o gestor liberar a avaliação",
      "add": "Adicionar Formulário",
      "edit": "Editar Formulário",
      "updateCounters": "Atualizar Contadores",
      "detailedResult": "Resultado Detalhado",
      "move": {
        "button": "Mover para {stage}",
        "title": "Mover Etapa",
        "text": "Tem certeza de que deseja mover este formulário para o estágio {stage}?"
      },
      "duplicate": {
        "button": "Duplicar",
        "title": "Duplicar Formulário",
        "text": "Tem certeza de que deseja duplicar este formulário?"
      },
      "delete": {
        "title": "Excluir Formulário",
        "text": "Tem certeza de que deseja excluir este formulário: {name}?"
      },
      "formQuestion": {
        "title": "Perguntas do Formulário",
        "question": "Pergunta",
        "itemOrder": "Ordem",
        "questionGroup": "Grupo de Perguntas",
        "add": "Adicionar Pergunta",
        "edit": "Editar Pergunta",
        "delete": {
          "title": "Excluir Pergunta",
          "text": "Tem certeza de que deseja excluir {name} deste formulário?"
        },
        "messages": {
          "saveSuccess": "Pergunta do Formulário salva com sucesso.",
          "saveError": "Ocorreu um erro ao salvar a Pergunta do Formulário.",
          "deleteSuccess": "Pergunta do Formulário excluída com sucesso.",
          "deleteError": "Ocorreu um erro ao excluir a Pergunta do Formulário.",
          "duplicateQuestion": "Esta pergunta já foi adicionada ao formulário.",
          "notFound": "Pergunta do Formulário não encontrada.",
          "questionNotFound": "Pergunta não encontrada."
        }
      },
      "messages": {
        "notFound": "Formulário não encontrado.",
        "saveSuccess": "Formulário salvo com sucesso.",
        "saveError": "Ocorreu um erro ao salvar o Formulário.",
        "deleteSuccess": "Formulário excluído com sucesso.",
        "deleteError": "Ocorreu um erro ao excluir o Formulário.",
        "deleteNotAllowed": "Não é possível excluir um formulário que não está na etapa de Preparação.",
        "isInUse": "Não é possível excluir o Formulário porque está em uso.",
        "atLeastOneMemberEvaluate": "Pelo menos um dos grupos destes campos precisa estar ativo: Avaliação de Relatório Direto, Autoavaliação, Avaliação entre Grupos ou Avaliação de Gestor.",
        "maximumHireDateRequired": "A Data Máxima de Contratação é obrigatória.",
        "dueDatesRequired": "Todas as datas de vencimento são obrigatórias.",
        "moveStageSuccess": "Formulário movido para o próximo estágio com sucesso.",
        "moveStageNotAllowed": "Não é possível mover um formulário fechado para outro estágio.",
        "moveStageNotAllowedNoPeople": "Formulário não tem participantes. Para mover, visite a página Participantes do Formulário para incluir participantes neste formulário.",
        "moveStageNotAllowedNoQuestions": "O formulário não tem perguntas. Para mover, insira pelo menos uma pergunta.",
        "duplicateSuccess": "Formulário duplicado com sucesso.",
        "updateCountersSuccess": "A atualização dos contadores foi iniciada.",
        "detailedResultSuccess": "A geração do resultado detalhado foi iniciada."
      }
    },
    "formEmailSender": {
      "menuTitle": "Disparar E-mail",
      "pageTitle": "Disparar E-mail",
      "messages": {
        "emailsSent": "E-mails enviados com sucesso."
      }
    },
    "questionnaire": {
      "questionnaireTypes": {
        "manager": "Gestor",
        "directReport": "Equipe",
        "crossGroup": "Cross Group",
        "selfEvaluation": "Autoavaliação",
        "freeEvaluation": "Avaliação Livre"
      },
      "questionnaireRequestTypes": {
        "default": "Padrão",
        "manager": "Gestor",
        "directReport": "Colaborador"
      },
      "questionnaireStatus": {
        "done": "Concluído",
        "declined": "Recusado",
        "open": "Em aberto"
      },
      "questionnairePriorityTypes": {
        "selfDirectManager": "Auto, Diretos e Gestor",
        "crossGroupPeers": "Cross Group (Pares)",
        "crossGroup": "Cross Groups",
        "freeEvaluation": "Avaliação Livre"
      },
      "questionnairesReport": {
        "title": "Relatório de Questionários",
        "messages": {
          "confirm": "O arquivo será exportado. Você receberá os resultados por e-mail em breve.",
          "success": "A exportação do relatório de questionários foi iniciada. Você receberá os resultados por e-mail em breve.",
          "emailNotFound": "Email não encontrado para realizar a exportação. Contate o administrador.",
          "formNotFound": "Formulário não encontrado para realizar a exportação. Contate o administrador.",
          "exportFailed": "Falha ao exportar o relatório de questionários."
        }
      },
      "createCrossGroupForMyself": {
        "menuTitle": "Solicitar minhas avaliações",
        "pageTitle": "Solicitar minhas avaliações",
        "form": "Formulário",
        "infoMessage": " Abaixo está o seu Cross Group padrão. Adicione colaboradores por quem você gostaria de ser avaliado(a). Você deve solicitar, no mínimo, 5 Cross Groups. Seu gestor irá revisar, ajustar se necessário e liberar as avaliações.",
        "warningReleasedQuestionnaires": "Você não pode adicionar novos avaliadores porque o seu gestor já aprovou as suas solicitações. Converse com sua liderança caso queira adicionar novos avaliadores.",
        "add": "Adicionar Colaborador",
        "evaluatorPerson": "Avaliador",
        "manager": "Gestor",
        "type": "Tipo",
        "requestType": "Solicitado por",
        "released": "Liberado",
        "status": "Status",
        "actions": "Ação",
        "delete": {
          "title": "Excluir Questionário",
          "text": "Tem certeza de que deseja excluir este questionário?"
        },
        "messages": {
          "alreadyExists": "Este questionário já existe para {names}. Em caso de dúvidas, fale com seu gestor.",
          "addSuccess": "Questionários criados com sucesso.",
          "deleteSuccess": "Questionário excluído com sucesso.",
          "invitedPersonWarning": "{names} já foi convidado(a) a fornecer feedback 360 em pelo menos {limit} outros formulários. Para incluí-los em formulários adicionais, selecione 'Salvar'. Se o feedback não for essencial, feche sem salvar e selecione outra pessoa para fornecer feedback."
        }
      },
      "crossGroupForMyTeam": {
        "menuTitle": "Aprovar solicitações para minha equipe",
        "pageTitle": "Aprovar solicitações para minha equipe",
        "form": "Formulário",
        "manager": "Gestor",
        "evaluatedPerson": "Colaborador avaliado",
        "evaluatorPerson": "Colaborador avaliador",
        "type": "Tipo",
        "released": "Liberado",
        "status": "Status",
        "loadCrossGroupDefaults": "Carregar CrossGroup Padrão",
        "unloadCrossGroupDefaults": "Retirar CrossGroup Padrão",
        "releaseQuestionnaire": "Liberar Questionários",
        "add": "Adicionar Questionário",
        "delete": {
          "title": "Excluir Questionário",
          "text": "Tem certeza de que deseja excluir este questionário?"
        },
        "messages": {
          "createdSuccess": "Questionários criados com sucesso.",
          "deletedSuccess": "Questionário excluído com sucesso.",
          "saveError": "Ocorreu um erro ao salvar o questionário. Tente novamente.",
          "questionnairesAlreadyExists": "Questionários já existem para: {names}.",
          "managerDisabledMessage": "Você não tem acesso a este formulário de grupo cruzado",
          "releasedSuccess": "Questionários liberados com sucesso.",
          "minCrossGroupEvaluations": "Apenas pessoas com pelo menos {value} questionários de grupo cruzado são exibidas.",
          "noQuestionnairesToRelease": "Não há questionários para liberar. Adicione pelo menos um questionário para liberar.",
          "isReadOnlyDueStage": "Este formulário é somente leitura e não pode ser editado",
          "remoteInstanceWarning": "Ocorreu um problema ao carregar as informações remotas.",
          "alreadyExists": "Este questionário já existe para {names}. Se tiver dúvidas, converse com seu gerente.",
          "minimumCrossGroupsNotMet": "O colaborador não possui o número mínimo de cross group ({current}/{minimum})",
          "questionnairesReleased": "Questionários liberados",
          "readyForRelease": "Pronto para liberação"
        },
        "crossGroupDefaults": {
          "loadDefaults": {
            "title": " Carregar Cross Group (Pares)",
            "messages": {
              "confirm": "Confirme se deseja carregar Cross Group (Pares) para todos os subordinados diretos.",
              "success": "Participantes padrão de Cross Group (Pares) carregados com sucesso."
            }
          },
          "unloadDefaults": {
            "title": "Retirar Cross Group (Pares)",
            "messages": {
              "confirm": "Confirme se deseja retirar Cross Group (Pares) para todos os subordinados diretos.",
              "success": "Participantes padrão Cross Group (Pares) retirados com sucesso."
            }
          }
        }
      },
      "crossGroupForMyRemoteTeam": {
        "menuTitle": "Aprovar solicitações para minha equipe (Global)",
        "pageTitle": "Aprovar solicitações para minha equipe (Global)"
      },
      "complete": {
        "menuTitle": "Realizar avaliações",
        "pageTitle": "Realizar avaliações",
        "form": "Formulário",
        "questionnaireType": "Tipo de Avaliação",
        "submit": "Enviar",
        "notApplicable": "N/A",
        "declinedCommentPlaceholder": "Não Aplicável",
        "reopen": "Reabrir",
        "status": {
          "new": "Avaliação não iniciada",
          "inProgress": "Avaliação em andamento",
          "completed": "Avaliação concluída"
        },
        "notApplicableTitle": "Recusar avaliação",
        "reopenTitle": "Confirmar cancelamento",
        "addFreeEvaluation": "Adicionar Avaliação Livre",
        "personToEvaluate": "Pessoa para avaliar",
        "freeEvaluationWarning": "As Avaliações Livres precisarão ser aprovadas pelos gestores e não contribuem para as pontuações gerais do 360.",
        "messages": {
          "loading": "Carregando avaliações...",
          "loadingGlobalQuestionnaires": "Carregando avaliações globais...",
          "formNotFound": "Formulário não encontrado.",
          "employeeNotFound": "Funcionário não encontrado.",
          "freeEvaluationNotAllowed": "Você não pode adicionar uma avaliação livre para você mesmo, seu gestor, seus pares ou seus subordinados diretos.",
          "alreadyExists": "Uma avaliação para esta pessoa já existe.",
          "submitConfirmation": "Ao clicar em enviar, a avaliação de {name} será registrada. Você pode refazer avaliações enviadas até que o processo de avaliações 360° avance para a etapa de Feedback do gestor.",
          "summaryValidate": "Valide as respostas e role para baixo para enviar. Clicar no X no canto superior direito não finalizará o seu envio.",
          "submitSuccess": "Avaliação enviada com sucesso.",
          "questionnaireNotFound": "Avaliação não encontrada.",
          "notSubmittedWarningMessage": "Esta avaliação ainda não foi enviada e não está sendo considerada na pontuação do funcionário.",
          "noQuestionnaires": "Você não tem nenhuma avaliação para completar.",
          "selectQuestionnaire": "Selecione uma avaliação para completar.",
          "employeeRateSummary": "Média final: ",
          "notApplicable": "Se você não é a pessoa adequada para completar esta avaliação de desempenho, pode recusar a responsabilidade, após fornecer um motivo.",
          "declineSuccess": "Avaliação recusada com sucesso.",
          "requiredQuestionnairesCompleted": "Todas as avaliações restantes podem ser concluídas a seu critério.",
          "allQuestionsRequired": "Todas as perguntas e comentários são obrigatórios para poder enviar.",
          "confirmReopen": "Tem certeza de que deseja cancelar a avaliação de {name}?",
          "reopenSuccess": "Avaliação reaberta com sucesso.",
          "questionnaireAlreadySubmitted": "Esta avaliação já foi enviada e não pode ser editada.",
          "addFreeEvaluationSuccess": "Avaliação livre adicionada com sucesso."
        }
      },
      "freeEvaluation": {
        "menuTitle": "Revisar avaliação livre",
        "menuTitleGlobal": "Revisar avaliação livre (Global)",
        "pageTitle": "Revisar avaliação livre",
        "pageTitleGlobal": "Revisar avaliação livre (Global)",
        "evaluatedPerson": "Pessoa avaliada",
        "view": "Visualizar",
        "infoMessage": "Revise as avaliações abaixo e aprove as que estiver de acordo. Caso não aprove uma avaliação, nenhuma ação adicional é necessária.",
        "messages": {
          "confirmApproval": "Tem certeza de que deseja aprovar o questionário?",
          "approvalSuccess": "Avaliação aprovada com sucesso.",
          "notFound": "Avaliação não encontrada."
        }
      }
    },
    "formPeople": {
      "participants": {
        "menuTitle": "Participantes do Formulário",
        "pageTitle": "Participantes do Formulário",
        "formId": "Formulário",
        "resetTree": "Redefinir árvore",
        "resetTreeTitle": "Redefinir árvore",
        "resetTreeText": "Tem certeza de que deseja redefinir a árvore?",
        "addPerson": "Adicionar participante",
        "changeManager": "Alterar gestor",
        "moveToAnotherManager": "Mover para outro gestor",
        "downloadTemplate": "Baixar modelo",
        "import": "Importar",
        "person": "Funcionário",
        "currentManager": "Gestor atual",
        "newManager": "Novo gestor",
        "messages": {
          "noNodeSelected": "Você precisa selecionar pelo menos um funcionário.",
          "saveSuccess": "Participantes do formulário salvos com sucesso.",
          "resetSuccess": "Participantes do formulário redefinidos com sucesso.",
          "formNotFound": "Formulario não encontrado.",
          "selectEmployee": "Selecione um funcionário primeiro",
          "addPersonSuccess": "Participante adicionado com sucesso.",
          "changeManagerSuccess": "Gestor alterado com sucesso.",
          "moveToManagerSuccess": "Pessoa movida para o novo gestor com sucesso.",
          "managerNotInTree": "O gestor selecionado não está na árvore.",
          "circularManagerSelection": "Não é possível mover um funcionário para um de seus próprios subordinados.",
          "importSuccess": "Arquivo importado com sucesso. Você receberá os resultados por e-mail em breve."
        },
        "errors": {
          "formInExecution": "Esta ação não pode ser executada porque o formulário está em execução no momento."
        }
      },
      "resultViewer": {
        "menuTitle": "Relatórios PDF",
        "pageTitle": "Relatórios PDF",
        "person": "Colaborador",
        "personHelpText": "Você pode selecionar você mesmo ou qualquer um dos seus subordinados diretos.",
        "personMultipleInstance": "Não selecione funcionários de várias instâncias. Os resultados podem estar incorretos ou incompletos.",
        "manager": "Gestor",
        "form": "Formulário",
        "position": "Cargo",
        "managerFeedback": "Feedback do gestor",
        "employeeFeedback": "Feedback do Colaborador",
        "pdfReport": "Relatório PDF",
        "pdfReportFreeEvaluation": "PDF de avaliação livre",
        "pdfReportFreeEvaluationNonApproved": "PDF de avaliação livre não aprovada",
        "downloadSelected360Report": "Baixar relatório 360 selecionado",
        "downloadSelectedFreeEvaluationReport": "Baixar relatório de avaliação livre selecionado",
        "downloadSelectedNonApprovedFreeEvaluationReport": "Baixar relatório de avaliação livre não aprovada selecionado",
        "emailSelected360Report": "Enviar por e-mail o relatório 360 selecionado",
        "emailSelectedFreeEvaluationReport": "Enviar por e-mail o relatório de avaliação livre selecionado",
        "emailSelectedNonApprovedFreeEvaluationReport": "Enviar por e-mail o relatório de avaliação livre não aprovada selecionado",
        "bulkEmailQueued": "Seus relatórios estão sendo preparados. Você receberá um e-mail com os PDFs em anexo em breve.",
        "bulkEmailNoSelection": "Selecione pelo menos uma linha.",
        "bulkEmailInvalidSelection": "Uma ou mais linhas selecionadas não são válidas para o seu acesso.",
        "bulkEmailNoReportForKind": "As linhas selecionadas não incluem este tipo de relatório.",
        "showFeedback": "Mostrar feedback",
        "downloadEvaluationSelectOne": "Selecione uma pessoa ou gestor.",
        "validationSelectPersonOrManager": "Selecione uma pessoa ou gestor para executar o filtro.",
        "successPdfByEmail": "O PDF foi enviado com sucesso para seu e-mail."
      },
      "sign": {
        "menuTitle": "Feedback",
        "menuTitleGlobal": "Feedback (Global)",
        "pageTitle": "Feedback",
        "pageTitleGlobal": "Feedback (Global)",
        "form": "Formulário",
        "person": "Colaborador",
        "managerOrPerson": "Gestor ou Colaborador",
        "managerSign": "Assinatura do Gestor",
        "personSign": "Assinatura do Colaborador",
        "sign": "Assinar",
        "signTitle": "Notas adicionais (opcional)",
        "signatureComments": "Comentários da Assinatura",
        "signed": "Assinado",
        "updateComment": "Atualizar Comentário",
        "pdfReport": "Relatório PDF",
        "pdfReportFreeEvaluation": "Relatório PDF Avaliação Livre",
        "messages": {
          "employeeSignatureNotAllowed": "A assinatura do funcionário não é permitida.",
          "managerSignatureNotAllowed": "A assinatura do gerente não é permitida.",
          "noComments": "Nenhum comentário disponível.",
          "signConfirmationManager": "Insira abaixo informações adicionais relacionadas ao processo de feedback com o membro da sua equipe.\n\nApós confirmar a assinatura, o relatório será liberado para o colaborador",
          "signConfirmationPerson": "Insira abaixo informações adicionais relacionadas ao processo de feedback com o seu gestor.",
          "signConfirmationWarning": "Uma vez assinado, você não poderá mais modificar este formulário.",
          "signedBy": "Assinado por {name} em {date}",
          "successMessage": "Assinatura concluída com sucesso.",
          "updateCommentSuccessMessage": "Comentário atualizado com sucesso."
        }
      }
    }
  },
  "security": {
    "menuTitle": "Segurança",
    "resource": {
      "menuName": "Recurso",
      "pageTitle": "Recurso",
      "add": "Adicionar recurso",
      "edit": "Editar recurso",
      "delete": {
        "title": "Excluir recurso",
        "text": "Tem certeza que deseja excluir este recurso?"
      },
      "id": "Id",
      "name": "Nome",
      "description": "Descrição",
      "resourceType": "Tipo de recurso",
      "isActive": "Está ativo",
      "messages": {
        "created": "Recurso criado com sucesso.",
        "updated": "Recurso atualizado com sucesso.",
        "deleted": "Recurso excluído com sucesso.",
        "notFound": "Registro de recurso não encontrado",
        "duplicateName": "Já existe um recurso com esse nome.",
        "inUse": "O recurso está em uso. Remova os usos primeiro."
      }
    },
    "user": {
      "menuName": "Usuário",
      "pageTitle": "Usuário",
      "subgridName": "Conta de usuário",
      "uniqueId": "Id único",
      "add": "Adicionar conta de usuário",
      "edit": "Editar conta de usuário",
      "delete": {
        "title": "Excluir conta de usuário",
        "text": "Tem certeza que deseja excluir esta conta?"
      },
      "personId": "Id",
      "provider": "Provedor",
      "userName": "Nome de usuário",
      "isActive": "Está ativo",
      "messages": {
        "created": "Conta criada com sucesso.",
        "updated": "Conta atualizada com sucesso.",
        "deleted": "Conta excluída com sucesso.",
        "notFound": "Registro não encontrado",
        "duplicateName": "Este nome de usuário já existe."
      }
    },
    "group": {
      "menuName": "Grupo",
      "pageTitle": "Grupo",
      "add": "Adicionar grupo",
      "edit": "Editar grupo",
      "delete": {
        "title": "Excluir grupo?",
        "text": "Tem certeza que deseja excluir este grupo?"
      },
      "id": "Id",
      "name": "Nome",
      "description": "Descrição",
      "isActive": "Está ativo",
      "overwriteGroups": "Sobrescrever grupos",
      "messages": {
        "created": "Grupo criado com sucesso.",
        "updated": "Grupo atualizado com sucesso.",
        "deleted": "Grupo excluído com sucesso.",
        "notFound": "Registro não encontrado",
        "duplicateName": "Já existe um grupo com esse nome.",
        "fileRequired": "O arquivo é obrigatório.",
        "imported": "Os grupos foram importados corretamente"
      }
    },
    "groupPeople": {
      "menuName": "Pessoas do grupo",
      "pageTitle": "Pessoas do grupo",
      "add": "Adicionar pessoas ao grupo",
      "edit": "Editar pessoas do grupo",
      "delete": {
        "title": "Excluir pessoas do grupo",
        "text": "Tem certeza que deseja excluir este registro?"
      },
      "groupId": "Grupo",
      "personId": "Pessoa",
      "validityStart": "Início da vigência",
      "validityEnd": "Fim da vigência",
      "messages": {
        "created": "Pessoa do grupo criada com sucesso.",
        "updated": "Pessoa do grupo atualizada com sucesso.",
        "deleted": "Pessoa do grupo excluída com sucesso.",
        "notFound": "Registro não encontrado",
        "alreadyExists": "O usuário já usa este grupo."
      }
    },
    "groupPermission": {
      "menuName": "Permissões",
      "pageTitle": "Permissões",
      "add": "Adicionar permissão",
      "edit": "Editar permissão",
      "delete": {
        "title": "Excluir permissão",
        "text": "Tem certeza que deseja excluir esta permissão?"
      },
      "groupId": "Grupo",
      "resourceId": "Recurso",
      "action": "Ação",
      "messages": {
        "created": "Permissão criada com sucesso.",
        "updated": "Permissão atualizada com sucesso.",
        "deleted": "Permissão excluída com sucesso.",
        "notFound": "Registro não encontrado",
        "duplicateName": "Já existe essa permissão para este recurso."
      }
    }
  },
  "goals": {
    "menuName": "Metas",
    "kpi": {
      "menuName": "KPI"
    },
    "plan": {
      "menuName": "Planos"
    },
    "target": {
      "menuName": "Metas",
      "kpiOwner": {
        "menuName": "Metas - Proprietário do KPI"
      }
    },
    "actual": {
      "menuName": "Atuais",
      "kpiOwner": {
        "menuName": "Atuais - Proprietário do KPI"
      }
    },
    "discussionNotes": {
      "menuName": "Notas de Discussão"
    },
    "flexibleGoal": {
      "menuName": "Meta Flexível"
    },
    "actionPlan": {
      "menuName": "Plano de Ação"
    },
    "library": {
      "menuName": "Biblioteca"
    },
    "category": {
      "menuName": "Categoria"
    },
    "PlantArea": {
      "menuName": "Área da Planta"
    },
    "clerks": {
      "menuName": "Proprietários de KPI"
    },
    "quickEntry": {
      "menuName": "Entrada Rápida Anual"
    }
  },
  "nineBox": {
    "menuName": "9box",
    "nineBoxForm": {
      "menuName": "Formulário"
    },
    "nineBoxFormPeople": {
      "menuName": "Participantes do Formulário"
    },
    "fillTalentTalk": {
      "menuName": "Guia Talent Talk"
    },
    "nineBoxCalibration": {
      "menuName": "Calibração"
    },
    "fillDevelopmentPlan": {
      "menuName": "PDI"
    }
  },
  "pcf": {
    "menuName": "PCF",
    "dashboard": {
      "menuName": "Dashboard"
    },
    "request": {
      "newPCF": {
        "menuName": "Novo PCF"
      }
    },
    "requestType": {
      "menuName": "Tipo de Solicitação"
    },
    "approvalGroup": {
      "menuName": "Grupo de Aprovação"
    },
    "requestStatuses": {
      "menuName": "Status da Solicitação"
    },
    "catalog": {
      "menuName": "Catálogo"
    },
    "immigrationType": {
      "menuName": "Tipo de Imigração"
    }
  },
  "merit": {
    "menuName": "Mericimento",
    "meritPlanFormList": {
      "menuName": "Lista de Formulários"
    },
    "meritDashboard": {
      "menuName": "Dashboard"
    },
    "meritPlan": {
      "menuName": "Plano"
    },
    "awardLetter": {
      "menuName": "Carta de Premiação"
    },
    "meritPlanParticipants": {
      "menuName": "Participantes do Plano de Mérito"
    }
  },
  "bonus": {
    "menuName": "Bônus",
    "bonusIncentiveGroup": {
      "menuName": "Grupo de Incentivo"
    },
    "bonusPlan": {
      "menuName": "Plano"
    },
    "bonusPlanParticipants": {
      "menuName": "Participantes do Plano"
    },
    "bonusDashboard": {
      "menuName": "Dashboard"
    },
    "awardLetter": {
      "menuName": "Carta de Premiação"
    },
    "saipAllocation": {
      "menuName": "Alocação SAIP",
      "messages": {
        "notFound": "Alocação SAIP não encontrada.",
        "saveError": "Ocorreu um erro ao salvar a Alocação SAIP. Tente novamente.",
        "saveSuccess": "Alocação SAIP salva com sucesso.",
        "deleteSuccess": "Alocação SAIP excluída com sucesso.",
        "isInUse": "A Alocação SAIP está em uso e não pode ser excluída.",
        "duplicateValueCode": "Os valores da Alocação SAIP não podem ter códigos duplicados.",
        "duplicateExternalId": "Já existe uma Alocação SAIP com este ID externo.",
        "valuesSumExceeded": "Os valores da Alocação SAIP não podem somar mais de 100%."
      }
    }
  },
  "cultureTalent": {
    "menuName": "Cultura e Talento",
    "culture": {
      "menuName": "Programas de Cultura e Talento"
    },
    "talent": {
      "menuName": "Plataformas de Treinamento"
    }
  },
  "talentMapping": {
    "menuName": "Mapeamento de Talentos",
    "skills": {
      "menuName": "Habilidades"
    },
    "orgChart": {
      "menuName": "Organograma"
    },
    "myProfile": {
      "menuName": "Meu Perfil"
    },
    "degreeTypes": {
      "menuName": "Tipo de Formação",
      "pageTitle": "Tipo de Formação",
      "name": "Nome",
      "isActive": "Está Ativo",
      "add": "Adicionar Tipo de Formação",
      "edit": "Editar Tipo de Formação",
      "delete": {
        "title": "Excluir Tipo de Formação",
        "text": "Tem certeza de que deseja excluir este Tipo de Formação?"
      },
      "messages": {
        "created": "Tipo de Formação criado com sucesso.",
        "updated": "Tipo de Formação atualizado com sucesso.",
        "deleted": "Tipo de Formação excluído com sucesso.",
        "saveError": "Ocorreu um erro ao salvar o Tipo de Formação. Por favor, tente novamente.",
        "notFound": "Registro de Tipo de Formação não encontrado.",
        "inUse": "O Tipo de Formação está em uso e não pode ser excluído."
      }
    }
  },
  "absenceRequest": {
    "menuName": "Solicitação de Ausência",
    "createRequest": {
      "menuName": "Criar Solicitação"
    },
    "viewManageRequests": {
      "menuName": "Minhas Solicitações"
    },
    "calendar": {
      "menuName": "Calendário"
    },
    "pendingRequestsAndHistory": {
      "menuName": "Aprovações"
    },
    "manageDirectReportsHours": {
      "menuName": "Manter Equilíbrios"
    },
    "upload": {
      "menuName": "Carregar"
    },
    "manageAbsenceProfiles": {
      "menuName": "Gerenciar Perfis de Ausência"
    },
    "manageHolidays": {
      "menuName": "Gerenciar Feriados"
    },
    "hoursCalculationMatrices": {
      "menuName": "Matrizes de Cálculo de Horas"
    },
    "manageApprovingDelegate": {
      "menuName": "Delegar Aprovações"
    },
    "notification": {
      "menuName": "Notificação de Ausência"
    },
    "manageMatrixCategories": {
      "menuName": "Gerenciar Categorias de Matriz"
    },
    "manageFloatingHolidayMatrix": {
      "menuName": "Gerenciar Matriz de Feriado Flutuante"
    },
    "manageSickMatrix": {
      "menuName": "Gerenciar Matriz de Doença"
    }
  },
  "expenseReport": {
    "menuName": "Relatórios de Despesas",
    "createExpenses": {
      "menuName": "Criar Despesa"
    },
    "myExpenses": {
      "menuName": "Minhas Despesas"
    },
    "approvals": {
      "menuName": "Despesas para Aprovar"
    },
    "delegateApprovals": {
      "menuName": "Delegar Aprovações"
    },
    "preparers": {
      "menuName": "Preparadores"
    },
    "categories": {
      "menuName": "Categorias"
    },
    "distanceRates": {
      "menuName": "Taxas de Distância"
    },
    "generalLedgers": {
      "menuName": "Contabilidades Gerais"
    },
    "policies": {
      "menuName": "Políticas"
    },
    "projects": {
      "menuName": "Projetos"
    }
  },
  "salaryExtraPay": {
    "menuName": "Pagamento Extra",
    "createRequest": {
      "menuName": "Criar Solicitação"
    },
    "myRequests": {
      "menuName": "Minhas Solicitações"
    },
    "approvals": {
      "menuName": "Aprovações"
    },
    "delegateApprovals": {
      "menuName": "Delegar Aprovações"
    },
    "locationSetups": {
      "menuName": "Configurações de Localização"
    },
    "export": {
      "menuName": "Exportar"
    },
    "policies": {
      "menuName": "Políticas"
    },
    "payType": {
      "menuName": "Tipos de Pagamento"
    },
    "personnelAreaSetups": {
      "menuName": "Configurações de Área de Pessoal"
    }
  },
  "developmentPlan": {
    "menuName": "Plano de Desenvolvimento",
    "planDelegate": {
      "menuName": "Delegar Plano"
    },
    "questions": {
      "menuName": "Perguntas"
    },
    "plans": {
      "menuName": "Planos"
    },
    "programs": {
      "menuName": "Programas"
    },
    "notificationSender": {
      "menuName": "Emissor de Notificação"
    },
    "fillDevelopmentPlan": {
      "menuName": "PDI"
    },
    "signEvaluations": {
      "menuName": "Assinar Avaliações"
    },
    "resultViewer": {
      "menuName": "Visualizador de Resultados"
    }
  },
  "survey": {
    "menuName": "Pesquisa",
    "questionCategories": {
      "menuName": "Categorias de Perguntas"
    },
    "questions": {
      "menuName": "Perguntas"
    },
    "ratingScales": {
      "menuName": "Escala de Avaliação"
    },
    "actionPlans": {
      "menuName": "Plano de Ação"
    },
    "people": {
      "menuName": "Pessoas"
    },
    "surveys": {
      "menuName": "Formulários de Pesquisa"
    },
    "notificationSender": {
      "menuName": "Emissor de Notificação"
    },
    "dashboard": {
      "menuName": "Dashboard"
    }
  },
  "hourlyPositions": {
    "menuName": "Cargos por hora",
    "createRequest": {
      "menuName": "Criar Solicitação"
    },
    "requests": {
      "menuName": "Solicitações"
    },
    "employeeSubgroup": {
      "menuName": "Subgrupo de Funcionários"
    },
    "hourlyCatalog": {
      "menuName": "Catálogo Horário"
    }
  },
  "vuestic": {
    "search": "Pesquisar",
    "noOptions": "Itens não encontrados",
    "ok": "OK",
    "cancel": "Cancelar",
    "uploadFile": "Selecionar arquivo",
    "undo": "Desfazer",
    "dropzone": "Solte os arquivos aqui para enviar",
    "fileDeleted": "Arquivo excluído",
    "closeAlert": "fechar alerta",
    "backToTop": "voltar ao topo",
    "toggleDropdown": "alternar menu suspenso",
    "carousel": "carrossel",
    "goPreviousSlide": "ir para o slide anterior",
    "goNextSlide": "ir para o próximo slide",
    "goSlide": "ir para o slide {index}",
    "slideOf": "slide {index} de {length}",
    "close": "fechar",
    "openColorPicker": "abrir seletor de cor",
    "colorSelection": "seleção de cor",
    "colorName": "cor {color}",
    "decreaseCounter": "diminuir contador",
    "increaseCounter": "aumentar contador",
    "selectAllRows": "selecionar todas as linhas",
    "sortColumnBy": "ordenar coluna por {name}",
    "selectRowByIndex": "selecionar linha {index}",
    "resetDate": "redefinir data",
    "nextPeriod": "próximo período",
    "switchView": "alternar visualização",
    "previousPeriod": "período anterior",
    "removeFile": "remover arquivo",
    "reset": "redefinir",
    "pagination": "paginação",
    "goToTheFirstPage": "ir para a primeira página",
    "goToPreviousPage": "ir para a página anterior",
    "goToSpecificPage": "ir para a página {page}",
    "goToSpecificPageInput": "inserir número da página",
    "goNextPage": "ir para a próxima página",
    "goLastPage": "ir para a última página",
    "currentRating": "classificação atual {value} de {max}",
    "voteRating": "votar classificação {value} de {max}",
    "optionsFilter": "filtro de opções",
    "splitPanels": "dividir painéis",
    "movePaginationLeft": "mover paginação para a esquerda",
    "movePaginationRight": "mover paginação para a direita",
    "resetTime": "redefinir hora",
    "closeToast": "fechar notificação",
    "selectedOption": "Opção selecionada",
    "noSelectedOption": "Nenhuma opção selecionada",
    "breadcrumbs": "migalhas de pão",
    "counterValue": "valor do contador",
    "selectedDate": "data selecionada",
    "selectedTime": "hora selecionada",
    "progressState": "estado do progresso",
    "color": "cor",
    "next": "Próximo",
    "back": "Voltar",
    "finish": "Finalizar",
    "step": "passo",
    "progress": "progresso",
    "loading": "Carregando",
    "sliderValue": "O valor atual do controle deslizante é {value}",
    "switch": "Alternar",
    "inputField": "Campo de entrada",
    "fileTypeIncorrect": "Tipo de arquivo incorreto",
    "select": "Selecionar uma opção"
  },
  "orgChart": {
    "title": "Organograma",
    "menuTitle": "Organograma",
    "menuName": "Organograma",
    "organization": "Organização",
    "directReports": "Subordinados Diretos",
    "showEmployeeDetails": "Ver detalhes do colaborador",
    "goUp": "Subir um nível",
    "navigateHere": "Navegar aqui",
    "vacant": "Vaga",
    "position": "Cargo",
    "plant": "Planta",
    "businessArea": "Área de Negócio",
    "personnelArea": "Área de Pessoal",
    "costCenter": "Centro de Custo",
    "hireDate": "Data de Admissão",
    "score360": "Nota 360",
    "scoreGoals": "Nota Metas",
    "score9box": "9-Box",
    "person": "Pessoa",
    "employeeType": "Tipo de Colaborador",
    "view": "Visão",
    "viewOptions": {
      "basic": "Básico",
      "performance": "Performance",
      "headcount": "Headcount"
    },
    "headcount": {
      "directTotal": "Total Direto",
      "directSESNE": "Direto SE/SNE",
      "total": "Total Headcount",
      "spanOfControl": "Amplitude de Controle",
      "se": "Salariados",
      "sne": "Empregados SNE",
      "hourly": "Horistas",
      "truck": "Motoristas",
      "work": "Work Release"
    },
    "hidePeers": "Ocultar pares",
    "showPeers": "Mostrar par(es)",
    "collapse": "Recolher",
    "expand": "Expandir",
    "errors": {
      "salariedTypeCannotBeRemoved": "O tipo assalariado não pode ser removido.",
      "employeeNotInTree": "Este funcionário está fora da árvore do Gráfico de Organização e não pode ser exibido."
    }
  }
}
